import {SliderInterface} from "@share/presentation/interfaces/SliderInterface";

export class ResizeHelper {
    private currentWidth = 0;
    private currentSlideSize = 0;
    private readonly observer: ResizeObserver | null = null;
    protected readonly debounceTIme = 150;

    constructor(
        private readonly element: HTMLElement,
        private readonly sliderInstance: SliderInterface,
        private readonly updateParamsFunction: () => void
    ) {
        this.currentSlideSize = this.sliderInstance.params.slideSize;
        this.currentWidth = this.element.offsetWidth;

        this.observer = new ResizeObserver(entries => {
            entries.forEach(entry => {
                const cr = entry.contentRect;
                const newWidth = Math.round(cr.width);

                if (newWidth != this.currentWidth) {
                    console.log('resize');
                    this.resizeHandler();
                    this.currentWidth = newWidth;
                }
            })
        });
    }

    addResizeListener() {
        this.observer?.observe(this.element);
    }

    removeResizeListener() {
        this.observer?.unobserve(this.element);
        this.observer?.disconnect();
    }

    private resizeHandler() {
        this.updateParamsFunction();

        if (this.sliderInstance.params.state) {
            const ratio = this.sliderInstance.params.state.offset / this.currentSlideSize;
            this.sliderInstance.params.state.offset = ratio * this.sliderInstance.params.slideSize;
        }

        this.currentSlideSize = this.sliderInstance.params.slideSize;
    }
}
